<form [formGroup]="frmGrpAssistenza" class="pb-0">

   <mat-form-field appearance="fill" class="w-full">
      <mat-label>Nome</mat-label>
      <input matInput tabindex="1" formControlName="from">
      <mat-error *ngIf="frmGrpAssistenza.get('from')?.hasError('required')">
         Nome <strong>richiesto</strong>
      </mat-error>
   </mat-form-field>

   <mat-form-field appearance="fill" class="w-full">
      <mat-label>Email</mat-label>
      <input matInput tabindex="1" formControlName="email">
      <mat-error *ngIf="frmGrpAssistenza.get('email')?.hasError('email')">
         Email <strong>invalida</strong>
      </mat-error>
      <mat-error *ngIf="frmGrpAssistenza.get('email')?.hasError('required')">
         Email <strong>Richiesta</strong>
      </mat-error>
   </mat-form-field>

   <mat-form-field appearance="fill" class="w-full">
      <mat-label>Titolo Richiesta</mat-label>
      <input matInput formControlName="title" autocomplete="nope" tabindex="2" (blur)="checkTitle($event)">
      <mat-error *ngIf="frmGrpAssistenza.get('title')?.hasError('required')">
         Titolo richiesta <strong>obbligatorio</strong>
      </mat-error>
      <mat-hint>Esporre il titolo della richiesta in modo esplicativo.</mat-hint>

   </mat-form-field>

   <mat-form-field appearance="fill" class="w-full">
      <mat-label>Richiesta</mat-label>
      <textarea matInput formControlName="body" autocomplete="nope" tabindex="2" rows="6"></textarea>
      <mat-error *ngIf="frmGrpAssistenza.get('body')?.hasError('required')">
         Inserisci la tua richiesta
      </mat-error>
   </mat-form-field>
</form>
<dx-file-uploader #fileUpload
                  class="btn btn-light p-0"
                  [multiple]="true"
                  uploadButtonText="Carica"
                  selectButtonText="Carica File"
                  labelText="Oppure trascina il file qui"
                  uploadMode="useForm">
</dx-file-uploader>
<small>Attenzione! Puoi caricare file per un massimo di 30mb</small>

<div>
   <button (click)="clickResetFile()">Resetta files</button>
</div>
<div class="pt-4">
   <button appDebounceClick [debounceTime]="500" type="button" class="ds-btn ds-btn-info" (debounceClick)="clickInvia()">
      Invia
   </button>
</div>
